export enum ItemSheetStatus {
  REQUESTED = "REQUESTED",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum ItemSheetExtraTag {
  OWN_PRODUCT = "own_product",
  PAST_PURCHASE = "past_purchase",
  GOOGLE_SEARCH = "google_search",
  FLOOR_PRICE = "floor_price",
  CUSTOM_PRICE = "custom_price",
  NEED_CONFIRM = "need_confirm",
}

export enum ItemSheetAuditLogAction {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  DOWNLOAD = "DOWNLOAD",
  CREATE_FROM_FILE = "CREATE_FROM_FILE",
  FINALIZE = "FINALIZE",
  UNFINALIZE = "UNFINALIZE",
}

export enum SMFItemType {
  RGNT = "RGNT",
  CMDTY = "CMDTY",
}
